<template>
  <div>
    <div style="display:grid;grid-template-columns: repeat(6, 1fr);grid-gap:0.5rem">
      <b-button style="grid-column:6/6" @click="showAddEditNDCsModal()" class="btn-add-ndc">Add NDC</b-button>
    </div>

    <grid
      has-pagination
      grid-id="ndcs-grid"
      :fields="fields"
      :items="referenceDrugKnownNDCsRecords"
      :filters="filtersObjArr"
      :get-items-function="getReferenceDrugKnownNDCsData"
      :total-rows="referenceDrugKnownNDCsPaging.totalItems"
      :current-page="referenceDrugKnownNDCsPaging.pageNumber"
      :per-page="referenceDrugKnownNDCsPaging.pageSize"
      :sort-by="referenceDrugKnownNDCsPaging.sortBy"
      :no-records="'No associated records found'"
      :sort-order="referenceDrugKnownNDCsPaging.sortOrder"
      @click-row="showAddEditNDCsModal($event)"
    />

    <b-modal
      :title="this.modalTitle"
      ref="addEditNDCsModal"
      ok-title="Save NDC Record"
      size="lg"
      @ok="onSaveNDCRecord"
    >
      <knownNDCsAddEditForm
        ref="knownNDCsAddEditForm"
        :knownNDCsDetail="knownNDCsObj"
        :isAddNDCsForm="isAddNDCsForm"
      />
    </b-modal>
  </div>
</template>


<script lang="ts">
import Vue from 'vue';
import _ from 'lodash';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import Grid from '@/shared/components/Grid';
import KnownNDCsAddEditForm from './Form/Index';
import { findObjectByPropertyNameInArray } from '@/shared/utils';
import { drugReferenceNDCsDto } from '../../../dto';

export default Vue.extend({
  name: 'KnownNDCs',
  props: ['brandId'],
  components: {
    Grid,
    KnownNDCsAddEditForm
  },
  data() {
    return {
      fields: [
        { key: 'ndC11', label: 'NDC11', tdClass: 'txt-link' },
        { key: 'ndcDescription', label: 'NDC Description' },
        { key: 'dosageFormName', label: 'Dosage/Form' },
        { key: 'labelerName', label: 'Labeler Name' }
      ],
      filtersObjArr: [
        { type: 'search', name: 'Search NDC11', fieldName: 'ndC11' }
      ],
      modalTitle: '',
      knownNDCsObj: {},
      isAddNDCsForm: false
    };
  },
  computed: {
    ...mapState('brandName', [
      'referenceDrugKnownNDCsRecords',
      'referenceDrugKnownNDCsPaging',
      'selectedBrandNameRecord',
      'copyNDCsFormData',
      'isNDC11AlreadyExists'
    ])
  },
  methods: {
    ...mapActions('brandName', [
      'getReferenceDrugKnownNDCs',
      'resetKnownNDCsPagingState',
      'updateReferenceDrugNDCsDetail',
      'saveReferenceDrugNDCsDetail'
    ]),

    showAddEditNDCsModal(ndcData) {
      const { brand } = this.selectedBrandNameRecord;

      let isEmptyNDCsData = _.isEmpty(ndcData);
      this.modalTitle = `${brand} NDC ${isEmptyNDCsData ? 'Add' : 'Edit'}`;

      if (!isEmptyNDCsData) {
        const existingRecord = findObjectByPropertyNameInArray(
          this.referenceDrugKnownNDCsRecords,
          'ndC11',
          ndcData.ndC11
        );

        this.knownNDCsObj = existingRecord;
        this.isAddNDCsForm = false;
      } else {
        this.knownNDCsObj = { ...drugReferenceNDCsDto, brandId: this.brandId };
        this.isAddNDCsForm = true;
      }

      this.$refs['addEditNDCsModal'].show();
    },

    async getReferenceDrugKnownNDCsData(pagingData) {
      if (pagingData) {
        pagingData.brandId = this.brandId;
      } else {
        pagingData = {};
        pagingData.brandId = this.brandId;
      }

      await this.getReferenceDrugKnownNDCs(pagingData);
    },

    async onSaveNDCRecord(event) {
      event.preventDefault();

      this.$refs.knownNDCsAddEditForm.$v.$touch();

      if (this.$refs.knownNDCsAddEditForm.$v.$invalid) {
        return;
      }

      if (this.isAddNDCsForm) {
        if (this.isNDC11AlreadyExists) return;
        await this.saveReferenceDrugNDCsDetail(this.copyNDCsFormData);
      } else {
        await this.updateReferenceDrugNDCsDetail(this.copyNDCsFormData);
      }

      this.$refs['addEditNDCsModal'].hide();
    }
  },
  async destroyed() {
    this.resetKnownNDCsPagingState();
  }
});
</script>



<style  scoped>
.btn-add-ndc {
  color: red;
  background-color: white;
  border: 1px solid black;
}
</style>